import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./accordion";
import { type Locale, getTranslationFn } from "../../i18n";

interface FAQsProps {
  locale: Locale;
}

export default function FAQs({ locale }: FAQsProps) {
  const t = getTranslationFn(locale);

  const faqData = [
    {
      q: t("Landing.faq.q1"),
      a: t("Landing.faq.a1"),
    },
    {
      q: t("Landing.faq.q2"),
      a: t("Landing.faq.a2"),
    },
    {
      q: t("Landing.faq.q3"),
      a: t("Landing.faq.a3"),
    },
    {
      q: t("Landing.faq.q4"),
      a: t("Landing.faq.a4"),
    },
    {
      q: t("Landing.faq.q5"),
      a: t("Landing.faq.a5"),
    },
    {
      q: t("Landing.faq.q6"),
      a: t("Landing.faq.a6"),
    },
    {
      q: t("Landing.faq.q7"),
      a: t("Landing.faq.a7"),
    },
    {
      q: t("Landing.faq.q8"),
      a: t("Landing.faq.a8"),
    },
  ];

  return (
    <section
      id="faq"
      className="scroll-py-16 py-16 md:scroll-py-32 md:py-32 bg-slate-50"
    >
      <div className="mx-auto max-w-5xl px-6">
        <div className="grid gap-y-12 px-2 lg:[grid-template-columns:1fr_auto] lg:gap-x-20">
          <div className="text-center lg:text-left">
            <h2 className="mb-4 text-3xl font-semibold md:text-4xl text-slate-900">
              {t("Landing.faq.title")} <br className="hidden lg:block" />{" "}
              {t("Landing.faq.title2")} <br className="hidden lg:block" />
              {t("Landing.faq.title3")}
            </h2>
            <p className="text-slate-600">{t("Landing.faq.subtitle")}</p>
          </div>

          <Accordion
            type="single"
            collapsible
            className="w-full sm:mx-auto sm:max-w-lg lg:mx-0 lg:w-[500px]"
          >
            {faqData.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
